import React, {Component} from 'react';
import mapboxgl from 'mapbox-gl';

mapboxgl.accessToken = 'pk.eyJ1IjoiYmlmaWR1c3Byb2R1Y2Npb25zIiwiYSI6ImNra3F4MDRmdjByOWEydXMxOHlpdW01Y28ifQ.Zj8FoxQAcpLjorUSc4Y2zQ';


class Mapa extends Component {	

    constructor(props) {
        super(props);
        this.state = {
        lng: 1.8627,
        lat: 42.1248,
        zoom: 9.5
        };
        }

    componentDidMount() {
            const map = new mapboxgl.Map({
            container: this.mapContainer,
            style: 'mapbox://styles/mapbox/streets-v11',
            center: [this.state.lng, this.state.lat],
            zoom: this.state.zoom
            });


            // Data: UN Human Development Index 2017 Europe extract
            // Source: https://ourworldindata.org/human-development-index
            var data = this.props.data;


            map.on('load', function () {

                // Carrega Vectors
                map.addSource('municipis', {
                type: 'vector',
                url: 'mapbox://bifidusproduccions.96vynygh'
                });

                // Build a GL match expression that defines the color for every vector tile feature
                // Use the ISO 3166-1 alpha 3 code as the lookup key for the country shape
                var matchExpression = ['match', ['get', 'codiine']];
                
                // Calculate color values for each country based on 'hdi' value
                data.forEach(function (row) {
                
                // Convert the range of data values to a suitable color
                var color = row['color'];
                matchExpression.push(row['codi'], color);
                
                });
                
                // Last value is the default, used where there is no data
                matchExpression.push('rgba(0, 0, 0, 0)');


                map.addLayer({
                    'id': 'municipis-fill',
                    'type': 'fill',
                    'source': 'municipis',
                    'source-layer': 'Lmits_administratius_municipa-9sn6b5',
                    'layout': {},
                    'paint': {
                        'fill-color': matchExpression,
                        'fill-opacity': 0.2
                        }
                    });



                map.addLayer({
                'id': 'municipis-linies',
                'type': 'line',
                'source': 'municipis',
                'source-layer': 'Lmits_administratius_municipa-9sn6b5',
                'layout': {
                'line-join': 'round',
                'line-cap': 'round'
                },
                'paint': {
                'line-color': matchExpression,
                'line-width': 2
                }
                });

                // When a click event occurs on a feature in the places layer, open a popup at the
                // location of the feature, with description HTML from its properties.
                // map.on('click', 'municipis-fill', function (e) {
                // var coordinates = [1.8627, 42.1248];
                // var codi = e.codi;
                
                // // Ensure that if the map is zoomed out such that multiple
                // // copies of the feature are visible, the popup appears
                // // over the copy being pointed to.
                // while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                // coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                // }
                
                // new mapboxgl.Popup()
                // .setLngLat(coordinates)
                // .setHTML(codi)
                // .addTo(map);
                // });
                
            });
                
                
        }
        render() {
            return (
                <div>
                    <div ref={el => this.mapContainer = el} className="mapContainer" />
                </div>
            )
        }
  }

  export default Mapa;